import React from "react";
import CountdownTimer from "../components/custom_hooks/timer";
import coin from "../assets/img/icons/coin.avif";

import { makeAPI } from "../services/api";

{/* Tournaments Section */ }

export default function Tournaments() {
    const imagePath = "/images/tournament-cards/";
    const [tournaments, setTournaments] = React.useState([]);
    const [timerEnded, setTimerEnded] = React.useState(false); // Track timer status

    React.useEffect(() => {
    document.title = "Tournaments - CGES.CLUB";

        const fetchTournaments = async () => {
            try {
                const response = await makeAPI('/api/tournament');
                setTournaments(response.data);
            } catch (error) {
                console.error('Error fetching tournaments:', error);
            }
        };
        fetchTournaments();
    }, [timerEnded]);

    return (
        <>
            <div className="uk-width-1-1@l">
                <h3 className="uk-text-lead">Our Tournaments</h3>

                {tournaments.length === 0 && <p>No tournaments available at the moment.</p>}

                <div className="uk-grid uk-grid-small uk-child-width-1-4@l uk-child-width-1-3@m uk-child-width-1-2@s" uk-grid="">
                    {tournaments.map((tournament, idx) => {
                        let tournament_duration = "7 Days";
                        return (
                            <div key={idx}>
                                <div className="fl-gp-box">
                                    <div className="fl-cover-image">
                                        <img alt="group" src={`${imagePath}${tournament.event_icon}`} />
                                        <div className="fl-gp-info-wrap">
                                            <div className="fl-gp-info">
                                                <div className="fl-gp-title">
                                                    <a href="14_group.html" className="bp-gp-home-link season-of-the-witch-home-link">{tournament?.event_title.toUpperCase() || ""}</a>
                                                </div>
                                                <div className="fl-gp-meta">
                                                    <div className="group-status"> <i className="icon-globe"></i><span style={{ color: tournament.tournament_status === "live" ? "red" : tournament.tournament_status === "upcoming" ? "#ff810e" : "green", fontWeight: "bolder" }}>{tournament.tournament_status?.toUpperCase() || ""}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="fl-gp-footer">
                                        <div className="fl-gp-cells">
                                            <div className="fl-gp-cell-left">
                                                <strong><img src={coin} width="15" height="15" alt="Coin icon" />&nbsp;{tournament.prize_pool}</strong>
                                                <span>Prize Pool</span>
                                            </div>
                                            <div className="fl-gp-cell-right">
                                                <strong> {tournament_duration}</strong>
                                                <span>Duration</span>
                                            </div>
                                        </div>
                                        <div className="fl-gp-action">
                                            <div className="">
                                                <span className="fl-gp-active">Ends on:&nbsp;<span style={{ color: "#ff810e" }}>{tournament.tournament_date.end + " (IST)"}</span></span>
                                                <span className="fl-gp-active"><i className="fa fa-clock"></i><CountdownTimer remainingSeconds={tournament?.end_time || 0} onTimerEnd={() => {console.log("Timer ended for tournament:");
                                                    setTimerEnded(prev => !prev)
                                                }} /></span>
                                            </div>
                                            <div className="fl-gp-button">
                                                <a className="fl-gp-button fl-join-group" rel="join" href={`/tournaments/${tournament.game_id}/${tournament.event_id}`}><i className="gg-icon gg-log-in"></i> Play</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}

